var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/language-picker/x-language-picker.ts
import { RXController } from "@adornis/chemistry/controllers/RXController.js";
import { event } from "@adornis/chemistry/decorators/event.js";
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-button.js";
import "@adornis/chemistry/elements/components/x-card.js";
import "@adornis/chemistry/elements/components/x-flex.js";
import { XDialog } from "@adornis/dialog/x-dialog.js";
import { FormField } from "@adornis/formfield/form-field.js";
import { globalLanguageSubject } from "@adornis/translation-core/client/languageSubject.js";
import { Language } from "@adornis/translation-core/languages.js";
import { html, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";
import { state } from "lit/decorators/state.js";
import { ref } from "lit/directives/ref.js";
import { repeat } from "lit/directives/repeat.js";
import { combineLatest, filter, switchMap, tap } from "rxjs";
import { getFlagByLangAbbreviation, getTranslatedLanguages } from "../../helpers/flag.js";
import { FullScreenDialog } from "./full-screen-dialog.js";
var XLanguagePicker = class extends FormField {
  constructor() {
    super(...arguments);
    this.value = new RXController(this, Language.ENGLISH);
    this.currentLanguage = new RXController(
      this,
      globalLanguageSubject.pipe(
        filter(Boolean),
        tap((lang) => this.value.next(lang))
      )
    );
    this.languages = new RXController(this, [Language.GERMAN, Language.ENGLISH]);
    this.original = new RXController(this, false);
    this.dialog = false;
    this.fullscreen = false;
    this.toggle = false;
    this.flagonly = false;
    this.flagsize = 50;
    this.displayLanguages = new RXController(
      this,
      combineLatest([this.value.observable, this.languages.observable, this.original.observable]).pipe(
        switchMap(([currentLanguage, languages, toOriginal]) => {
          return getTranslatedLanguages(currentLanguage ?? "en", languages, toOriginal);
        })
      )
    );
  }
  render() {
    if (this.dialog || this.fullscreen)
      return this._dialog();
    if (this.toggle)
      return this._toggleWrapper();
    return this._dropdown();
  }
  _toggleItem(lang) {
    if (!lang)
      return nothing;
    return html`
      <x-text
        ${css({
      cursor: "pointer",
      userSelect: "none",
      color: this.value.value === lang ? "red" : "black"
    })}
        @click=${() => globalLanguageSubject.next(lang)}
      >
        ${lang}
      </x-text>
    `;
  }
  _flagToggle() {
    return html`
      <img
        @click=${() => globalLanguageSubject.next(
      this.value.value === this.languages.value?.[0] ? this.languages.value[1] : this.languages.value[0]
    )}
        ${css({ cursor: "pointer", width: this.flagsize + "px", height: this.flagsize / 1.5 + "px" })}
        src="${getFlagByLangAbbreviation(this.value.value)}"
      />
    `;
  }
  _toggleWrapper() {
    if (this.flagonly)
      return this._flagToggle();
    return html`
      <x-flex horizontal space="xs" crossaxis-center>
        ${this._toggleItem(this.languages.value?.[0])}
        <x-text> | </x-text>
        ${this._toggleItem(this.languages.value?.[1])}
      </x-flex>
    `;
  }
  _dialog() {
    return html`
      <x-flex
        @click=${() => {
      return (this.fullscreen ? FullScreenDialog : XDialog).showPopup({
        content: (close) => html`
              <x-flex padding="md" space="md" center crossaxis-center>
                <x-h3> Sprache auswählen </x-h3>
                ${this._flagList(close)}
              </x-flex>
            `
      });
    }}
      >
        ${this._singleFlag(this.value.value)}
      </x-flex>
    `;
  }
  _dropdown() {
    return html`
      <x-dropdown ${ref((trigger) => this._trigger = trigger)} id="countrypick">
        <x-flex horizontal space="sm" slot="trigger" @click=${() => this._trigger?.open()}>
          ${this._singleFlag(this.value.value)}
        </x-flex>

        <x-card slot="dropdown-content">
          <x-flex @click=${() => this._trigger?.close()}> ${this._flagList()} </x-flex>
        </x-card>
      </x-dropdown>
    `;
  }
  _flagList(close) {
    return html`
      <x-flex space="sm"> ${repeat(this.languages.value || [], (lang) => this._singleFlag(lang, close))} </x-flex>
    `;
  }
  _singleFlag(lang, close) {
    if (!this.displayLanguages.value)
      return nothing;
    return html`
      <x-flex
        horizontal
        crossaxis-center
        space="sm"
        ${css({ cursor: "pointer", userSelect: "none" })}
        @click=${() => {
      globalLanguageSubject.next(lang);
      if (close)
        close();
    }}
      >
        <img
          ${css({ width: this.flagsize + "px", height: this.flagsize / 1.5 + "px", pointerEvents: "none" })}
          src="${getFlagByLangAbbreviation(lang)}"
        />

        <x-text> ${this.displayLanguages.value[lang] || ""} </x-text>
      </x-flex>
    `;
  }
};
__decorateClass([
  state(),
  event
], XLanguagePicker.prototype, "value", 2);
__decorateClass([
  state()
], XLanguagePicker.prototype, "currentLanguage", 2);
__decorateClass([
  state()
], XLanguagePicker.prototype, "languages", 2);
__decorateClass([
  property({ type: Boolean })
], XLanguagePicker.prototype, "original", 2);
__decorateClass([
  property({ type: Boolean })
], XLanguagePicker.prototype, "dialog", 2);
__decorateClass([
  property({ type: Boolean })
], XLanguagePicker.prototype, "fullscreen", 2);
__decorateClass([
  property({ type: Boolean })
], XLanguagePicker.prototype, "toggle", 2);
__decorateClass([
  property({ type: Boolean })
], XLanguagePicker.prototype, "flagonly", 2);
__decorateClass([
  property({ type: Number })
], XLanguagePicker.prototype, "flagsize", 2);
__decorateClass([
  state()
], XLanguagePicker.prototype, "displayLanguages", 2);
XLanguagePicker = __decorateClass([
  customElement("x-language-picker")
], XLanguagePicker);
export {
  XLanguagePicker
};
